$('.account-opening-sidebar a, .account-opening-content .nav-link').click(function() {
    $('.account-opening-content .accordion-head').addClass('collapsed');
    $('.account-opening-content .accordion-head').attr('aria-expanded', 'false');
    $('.account-opening-content .accordion-content').removeClass('show');
});